var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "LoginForm" }, [
    _vm.isApiSuccess
      ? _c("div", [
          _c("div", { staticClass: "login-form-row" }, [
            _c("h2", [
              _vm._v(_vm._s(_vm.trans("reset_password_title_success")))
            ])
          ]),
          _c("div", { staticClass: "form-row success" }, [
            _c("img", { attrs: { src: "/assets/images/success.svg", alt: "" } })
          ]),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "input-wrapper" }, [
              _c(
                "button",
                {
                  class: { "btn-primary": true },
                  on: {
                    click: function($event) {
                      return _vm.back()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "btn-text" }, [
                    _vm._v(
                      " " + _vm._s(_vm.trans("back_to_login_button")) + " "
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      : _vm._e(),
    !_vm.isApiSuccess
      ? _c("div", [
          _c("div", { staticClass: "login-form-row" }, [
            _c("h2", [_vm._v(_vm._s(_vm.trans("reset_password_title")))])
          ]),
          _c("div", { staticClass: "login-form-row" }, [
            _c("p", [_vm._v(_vm._s(_vm.trans("reset_password_description")))])
          ]),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "label-wrapper" }, [
              _c("div", { staticClass: "label-left" }, [
                _c("label", { attrs: { for: "password" } }, [
                  _vm._v(_vm._s(_vm.trans("new_password_title")))
                ])
              ])
            ]),
            _c("div", { staticClass: "input-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "password-watcher",
                  on: { click: _vm.inputTypeToogle }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d:
                            "M7 1.75C11.3841 1.75 13.8392 6.53333 13.9562 6.76667C14.0146 6.88333 14.0146 7.11667 13.9562 7.23333C13.8392 7.46667 11.3841 12.25 7 12.25C2.87342 12.25 0.455869 8.01217 0.0885714 7.36832L0.0885657 7.36831C0.0656446 7.32813 0.0507089 7.30195 0.0438413 7.29167C-0.0146138 7.11667 -0.0146138 6.94167 0.0438413 6.76667C0.160752 6.53333 2.61587 1.75 7 1.75ZM1.21294 7C1.79749 7.93333 3.84342 11.0833 6.99999 11.0833C10.1566 11.0833 12.2025 7.93333 12.787 7C12.2025 6.06667 10.1566 2.91667 6.99999 2.91667C3.84342 2.91667 1.73903 6.06667 1.21294 7ZM6.99998 4.66667C5.71397 4.66667 4.66177 5.71667 4.66177 7C4.66177 8.28333 5.71397 9.33333 6.99998 9.33333C8.28599 9.33333 9.33818 8.28333 9.33818 7C9.33818 5.71667 8.28599 4.66667 6.99998 4.66667ZM5.83089 7C5.83089 7.64167 6.35698 8.16667 6.99999 8.16667C7.643 8.16667 8.16909 7.64167 8.16909 7C8.16909 6.35833 7.643 5.83333 6.99999 5.83333C6.35698 5.83333 5.83089 6.35833 5.83089 7Z",
                          fill: "black"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm.inputType === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formModel.password,
                        expression: "formModel.password"
                      }
                    ],
                    staticClass: "password",
                    class: {
                      error: _vm.$v.formModel.password.$error || _vm.isApiError
                    },
                    attrs: {
                      name: "password",
                      id: "password",
                      type: "checkbox"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.formModel.password)
                        ? _vm._i(_vm.formModel.password, null) > -1
                        : _vm.formModel.password
                    },
                    on: {
                      focusout: function($event) {
                        return _vm.$v.formModel.password.$touch()
                      },
                      change: function($event) {
                        var $$a = _vm.formModel.password,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.formModel,
                                "password",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.formModel,
                                "password",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.formModel, "password", $$c)
                        }
                      }
                    }
                  })
                : _vm.inputType === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formModel.password,
                        expression: "formModel.password"
                      }
                    ],
                    staticClass: "password",
                    class: {
                      error: _vm.$v.formModel.password.$error || _vm.isApiError
                    },
                    attrs: { name: "password", id: "password", type: "radio" },
                    domProps: { checked: _vm._q(_vm.formModel.password, null) },
                    on: {
                      focusout: function($event) {
                        return _vm.$v.formModel.password.$touch()
                      },
                      change: function($event) {
                        return _vm.$set(_vm.formModel, "password", null)
                      }
                    }
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formModel.password,
                        expression: "formModel.password"
                      }
                    ],
                    staticClass: "password",
                    class: {
                      error: _vm.$v.formModel.password.$error || _vm.isApiError
                    },
                    attrs: {
                      name: "password",
                      id: "password",
                      type: _vm.inputType
                    },
                    domProps: { value: _vm.formModel.password },
                    on: {
                      focusout: function($event) {
                        return _vm.$v.formModel.password.$touch()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.formModel, "password", $event.target.value)
                      }
                    }
                  }),
              _vm.$v.formModel.password.$error
                ? _c("span", { staticClass: "error" }, [
                    _vm._v(" " + _vm._s(_vm.trans("password_error")) + " ")
                  ])
                : _vm._e(),
              _vm.isApiError && !_vm.$v.formModel.password.$error
                ? _c("span", { staticClass: "error" }, [_vm._v(" ")])
                : _vm._e(),
              _vm.isApiError && !_vm.$v.formModel.password.$error
                ? _c("span", { staticClass: "error" }, [_vm._v(" ")])
                : _vm._e(),
              _c("div", { staticClass: "password-validator" }, [
                _c("div", { staticClass: "password-validator-row" }, [
                  _c(
                    "label",
                    {
                      class: {
                        success: _vm.$v.formModel.password.passwordValidatorMin8
                      }
                    },
                    [_vm._v(_vm._s(_vm.trans("password_min8")))]
                  )
                ]),
                _c("div", { staticClass: "password-validator-row" }, [
                  _c(
                    "label",
                    {
                      class: {
                        success:
                          _vm.$v.formModel.password
                            .passwordValidatorMinUppercase
                      }
                    },
                    [_vm._v(_vm._s(_vm.trans("password_min_uppercase")))]
                  )
                ]),
                _c("div", { staticClass: "password-validator-row" }, [
                  _c(
                    "label",
                    {
                      class: {
                        success:
                          _vm.$v.formModel.password.passwordValidatorMinNumber
                      }
                    },
                    [_vm._v(_vm._s(_vm.trans("password_min_number")))]
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "input-wrapper" }, [
              _c(
                "button",
                {
                  class: { "btn-primary": true, loading: _vm.isLoading },
                  on: {
                    click: function($event) {
                      return _vm.submit()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "loader" }, [
                    _c("img", { attrs: { src: "/assets/images/loader.svg" } })
                  ]),
                  _c("div", { staticClass: "btn-text" }, [
                    _vm._v(" " + _vm._s(_vm.trans("send_button")) + " ")
                  ])
                ]
              ),
              _c("div", { class: { "be-error": true } }, [
                _vm.isApiError
                  ? _c("span", { staticClass: "error" }, [
                      _vm._v(
                        " " + _vm._s(_vm.trans("reset_password_error")) + " "
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }